module.exports = __webpack_public_path__ + "media/images/logo-otec-manager-blanco-94fb4553534b4cf2c0b1703dccf4695c.png";